module.exports = __webpack_public_path__ + "img/ic-safe.19192915.png";